import { render } from "./DoughnutChart2.vue?vue&type=template&id=80fcd81c&scoped=true"
import script from "./DoughnutChart2.vue?vue&type=script&lang=js"
export * from "./DoughnutChart2.vue?vue&type=script&lang=js"

import "./DoughnutChart2.vue?vue&type=style&index=0&id=80fcd81c&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fcd81c"]])

export default __exports__